import React, { useMemo } from 'react';
import UpsellBlock from '../../Blocks/UpsellBlock';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const CheckoutUpsellBlockContainer = ({
  containerId,
}: {
  containerId: string;
}) => {
  const { upsellBlocks } = useTypedSelector((state) => state.checkout);

  const blocks = useMemo(
    () => upsellBlocks[containerId] ?? undefined,
    [containerId, upsellBlocks]
  );

  return (
    <>
      {blocks &&
        blocks.map((b, idx) => (
          <UpsellBlock {...b} key={'upsell-block-' + idx} />
        ))}
    </>
  );
};

export default CheckoutUpsellBlockContainer;
